var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.textArr),function(item,index){return _c('div',{key:index,staticClass:"br_item"},[_vm._v(_vm._s(item)+" "),(item == '')?_c('br'):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }